"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsiveContainer } from "recharts";
import clsx from "clsx";
import { ChartThemeProvider, DEFAULT_CHART_THEME } from "./theme.js";
const buildCssVariables = (theme) => {
    const palette = theme.palette.length > 0 ? theme.palette : DEFAULT_CHART_THEME.palette;
    const paletteVariables = palette.reduce((acc, color, index) => {
        const key = `--chart-series-${index + 1}`;
        acc[key] = color;
        return acc;
    }, {});
    return {
        "--chart-bg": theme.background,
        "--chart-border-color": theme.borderColor,
        "--chart-text-color": theme.textColor,
        "--chart-axis-color": theme.axisColor,
        "--chart-grid-color": theme.gridColor,
        "--chart-tooltip-bg": theme.tooltipBackground,
        "--chart-tooltip-border": theme.tooltipBorderColor,
        ...paletteVariables,
    };
};
const mergeTheme = (theme) => ({
    ...DEFAULT_CHART_THEME,
    ...theme,
    palette: theme?.palette && theme.palette.length > 0 ? theme.palette : DEFAULT_CHART_THEME.palette,
});
export function ChartContainer({ children, className, height = 280, minHeight, theme, responsive = true, }) {
    const mergedTheme = mergeTheme(theme);
    const style = buildCssVariables(mergedTheme);
    const containerStyle = {
        height,
        minHeight: minHeight ?? height,
        background: "var(--chart-bg)",
        borderColor: "var(--chart-border-color)",
    };
    const content = responsive ? (_jsx(ResponsiveContainer, { width: "100%", height: "100%", children: children })) : (children);
    return (_jsx(ChartThemeProvider, { value: mergedTheme, children: _jsx("div", { className: clsx("chart-container relative flex h-full w-full flex-col overflow-hidden rounded-2xl border px-4 pb-4 pt-6", className), style: { ...style, ...containerStyle }, children: content }) }));
}
